const StarActiveSvg = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill="none">
            <path fill="#F9B023" d="M13.388 4.56H9.68L8.532 1.005a.996.996 0 0 0-.946-.694.997.997 0 0 0-.948.694L5.493 4.559H1.785a.997.997 0 0 0-.947.694c-.133.413.013.866.362 1.122l3 2.196-1.146 3.553c-.133.413.013.866.362 1.122a.99.99 0 0 0 1.171 0l3-2.197 3.001 2.197a.99.99 0 0 0 1.17 0c.35-.256.496-.709.362-1.122L10.974 8.57l2.977-2.18c.26-.181.432-.484.432-.827a.999.999 0 0 0-.995-1.004Z"/>
        </svg>
    )
}

export default StarActiveSvg;